import { PLAYGROUND_SYM } from "./playground";
export const PLAYGROUND_ORIGIN = "https://naas.ymcu.libum.io";
export const MAX_REQUEST_BYTES = 256 * 1024;

/** The client never accepts a destination from inputs, storage, or the URL. */
export function requestUrl(path: string, parameters: Record<string, string>) {
  if (!/^\/(?:[a-zA-Z0-9_{}.-]+\/?)*$/.test(path))
    throw new Error("Invalid playground endpoint.");
  const route = path.replace(/\{([^}]+)\}/g, (_, key) => {
    const value = key === "sym" ? PLAYGROUND_SYM : parameters[key]?.trim();
    if (!value) throw new Error(`Enter ${key}.`);
    if (!/^[a-zA-Z0-9_.-]+$/.test(value) || value === "." || value === "..")
      throw new Error(`Invalid ${key}.`);
    return encodeURIComponent(value);
  });
  if (
    /[{}]/.test(route) ||
    route.split("/").some((part) => part === "." || part === "..")
  )
    throw new Error("Invalid playground endpoint.");
  const url = new URL(route, PLAYGROUND_ORIGIN);
  if (url.origin !== PLAYGROUND_ORIGIN)
    throw new Error("Invalid playground endpoint.");
  return url.toString();
}
export async function readLimitedResponse(
  response: Response,
  limit = 256 * 1024,
) {
  const reader = response.body?.getReader();
  if (!reader) return "";
  const decoder = new TextDecoder();
  let result = "";
  let size = 0;
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const remaining = limit - size;
      result += decoder.decode(value.subarray(0, remaining), { stream: true });
      size += value.length;
      if (size >= limit) {
        await reader.cancel();
        return result + "\n[Response preview truncated at 256 KB]";
      }
    }
    return result + decoder.decode();
  } finally {
    reader.releaseLock();
  }
}
